import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop";

import Home from "./views/Home";
import Shipping from "./views/Step10_Shipping";
import Interests from "./views/Step20_Interests";
import Participants from "./views/Step30_Participants";
import Events from "./views/Step40_Events";
import Workshops from "./views/Step50_Workshops";
import Checkout from "./views/Step60_Checkout";
import Confirmation from "./views/Step70_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";
import SessionTimeOut from "./views/components/SessionTimeOut";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/:language/sessiontimeout" element={<SessionTimeOut />} />

                <Route path="/" element={<Navigate to="/en/home" replace />} />
                <Route path="/:language/home" element={<Home />} />
                <Route path="/:language/shipping" element={<Shipping />} />
                <Route path="/:language/interests" element={<Interests />} />
                <Route path="/:language/participants" element={<Participants />} />
                <Route path="/:language/events" element={<Events />} />
                <Route path="/:language/workshops" element={<Workshops />} />
                <Route path="/:language/checkout" element={<Checkout />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
